import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;
// const user = "bala";
// const code = 2



export class OnBoardingServices {
    constructor() {}
    checkIsfcCode(event) {
        const uri = `/api/bank-branches/ifsc-code/` + event;
        return apiHelper.get(uri);
    }
    getOnBoardingDetails(categoryCode, companyCode, partnerCategory) {
        const uri = `/api/partner-summaries/general-retrieval/category-code/${categoryCode}/company-code/${companyCode}/partner-category/${partnerCategory}`;
        return apiHelper.get(uri);
    }
    insertIFSCCode(data){
        const uri = `/api/admin/bank-branches`;
        return apiHelper.post(uri, data);
    }
    getCountriesForRegdOffice() {
        const uri = `/api/country`;
        return apiHelper.get(uri);
    }
    getSectors(){
        const uri = `/api/misc-type-details/misc-code/24`;
        return apiHelper.get(uri);
    }
    getNatures(){
        const uri = `/api/misc-type-details/misc-code/25`;
        return apiHelper.get(uri)
    }
    getCustomerGroups(){
        const uri = `/api/misc-type-details/misc-code/26`;
        return apiHelper.get(uri)
    }
    getStatesForRegisteredOffice(countryCode) {
        const uri = `/api/state/country/${countryCode}`
        return apiHelper.get(uri)
    }
    getCityForRegisteredOffice(cityCode) {
        const uri = `/api/city/state/${cityCode}`
        return apiHelper.get(uri)
    }

    getPfOfficeAddress() {
        const uri = `/api/employment-address/pf`
        return apiHelper.get(uri)
    }
    getESIOfficeAddress() {
        const uri = `/api/employment-address/esi`
        return apiHelper.get(uri)
    }

    getBoardingHeadings() {
        const uri = `/api/onboard-module`;
        return apiHelper.get(uri);
    }
    getBoardingQuestions(user, moduleCode, categoryCode, companyCode,isInternational) {
        const uri = `/api/onboard-questions/module-code/${moduleCode}/category-code/${categoryCode}/company-code/${companyCode}/isInternational/${isInternational}`;
        return apiHelper.get(uri);
    }
    getGeneralDetails(code, companyCode) {
        const uri = `/api/general-module/category-code/${code}/company-code/${companyCode}`;
        return apiHelper.get(uri);
    }
    getDynamicDropdown(url) {
        const uri = url;
        return apiHelper.getExternal(uri);
    }
    getStatutoryIncorporated() {
        const uri = `/api/ownership-types`;
        return apiHelper.get(uri);
    }
    getRegisteredCodeReference(code) {
        const uri = `/api/general-module/category-code/${code}`;
        return apiHelper.get(uri);
    }

    getProjectType() {
        const uri = `/api/misc-type-details/misc-code/3`;
        return apiHelper.get(uri);
    }
    getRefernceOption() {
        const uri = `/api/misc-type-details/misc-code/14`;
        return apiHelper.get(uri);
    }

    getProjectOrgin() {
        const uri = `/api/misc-type-details/misc-code/4`;
        return apiHelper.get(uri);
    }
    getPartnerTypes(companyCode) {
        const uri = `/api/business-category/business-types/company-code/${companyCode}`;
        return apiHelper.get(uri);
    }

    getCurrency(countryCode) {
        const uri = `/api/currency/country-code/${countryCode}`;
        return apiHelper.get(uri);
    }

    getBankName() {
        const uri = `/api/bank`;
        return apiHelper.get(uri);
    }
    getCompanyList(pid) {
        const uri = `/api/companyMapping/allcompanies/partnerId/${pid}`;
        return apiHelper.get(uri);
    }
    getBankAccountCategory() {
        const uri = `/api/bank-account-category`;
        return apiHelper.get(uri);
    }


    getAccountType() {
        const uri = `/api/bank-account-types`;
        return apiHelper.get(uri);
    }

    getPartnerDetailsId() {
        const uri = `/api/partner/info`
        return apiHelper.get(uri);
    }

    getBussinessVertical(companyCode) {
        const uri = `/api/cluster-elements-details/cecode/2/companyCode/${companyCode}`
        return apiHelper.get(uri);
    }
    getBussinessRegion(businessType,companyCode) {
        const uri = `/api/cluster-elements-details/cecode/6/parent-ced-code/${businessType}/companyCode/${companyCode}`
        return apiHelper.get(uri);
    }

    resubmitAddCompany(data){        
        const uri = "/api/companyMapping/addCompany/re-submit"
        return apiHelper.post(uri, data)
    }
    getBussinessType(categoryCode, companyCode) {
        const uri = `/api/partner-business-types/category/${categoryCode}/company-code/${companyCode}`
        return apiHelper.get(uri);
    }


    getRatingAgencyOptions() {
        const uri = `/api/rating-agency`
        return apiHelper.get(uri)
    }
    uploadAttachments(data) {
        const uri = "/api/fileUpload"
        return apiHelper.postFile(uri, data);
    }
    downloadAttachments(uniqueId) {
        const uri = `/api/fileDownload/${uniqueId}`
        return apiHelper.get(uri)
    }
    getOtherFinancialDetails() {
        const uri = `/api/misc-type-details/misc-code/5`
        return apiHelper.get(uri)
    }
    saveFinancialDetails(data) {
        const uri = "/api/onboard-finance"
        return apiHelper.post(uri, data)
    }

    saveFinancialPerformance(data) {
        const uri = "/api/onboard-financial/financial-performance"
        return apiHelper.post(uri, data)
    }
    saveFinancialStrength(data, category) {
        if (category == "B") {
            const uri = "/api/branch/financial-strength"
            return apiHelper.post(uri, data)
        } else {
            const uri = "/api/onboard-financial/financial-strength"
            return apiHelper.post(uri, data)
        }

    }
    saveFinancialOthers(data) {
        const uri = "/api/onboard-financial/others"
        return apiHelper.post(uri, data)
    }
    fetchFinanceDetails(categoryCode, companyCode) {
        const uri = `/api/partner-summaries/financial-retrieval/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.get(uri)
    }

    saveOnboardingAnswerDraft(data) {
        const uri = "/api/onboard-answer-heads/draft"
        return apiHelper.post(uri, data)
    }

    getQuestionsPercentageCompleted(categoryCode, companyCode, isInternational) {
        const uri = `/api/onboard-questions/category-code/${categoryCode}/company-code/${companyCode}/isInternational/${isInternational}`
        return apiHelper.get(uri)
    }

    checkUsername(name) {
        const uri = `/api/user/verify/${name}`
        return apiHelper.get(uri)
    }
    submitOnboardingDetails(categoryCode, companyCode) {
        const uri = `/api/partnerportal/workflow/onboard-module/submit/category/${categoryCode}/company-code/${companyCode}`
        return apiHelper.post(uri)
    }
    saveOnBoardingDetails(onBoardingdata) {
        const uri = `/api/general-module`
        return apiHelper.post(uri, onBoardingdata)
    }
    saveOrgDetails(onBoardingdata) {
        const uri = `/api/general-module/save/org-details`;
        return apiHelper.post(uri, onBoardingdata)
    }
    saveBankDetails(onBoardingdata, isMigratedUser) {
        const uri = `/api/general-module/save/bank-details`;
        onBoardingdata.isMigratedUser = isMigratedUser
        return apiHelper.post(uri, onBoardingdata)
    }
    savePartnerDetails(onBoardingdata) {
        const uri = `/api/general-module/save/credential`;
        return apiHelper.post(uri, onBoardingdata)
    }
    saveOtherDetails(onBoardingdata) {
        const uri = `/api/general-module/save/partnership-avenue`;
        return apiHelper.post(uri, onBoardingdata)
    }
    saveBranchDetails(onBoardingdata) {
        const uri = `/api/general-module/save/branch`;
        return apiHelper.post(uri, onBoardingdata)
    }
    getYearOfIncorporation(categoryCode, companyCode) {
        const uri = `/api/general-module/year-incorporated/mandatory/category-code/${categoryCode}`;
        return apiHelper.get(uri)
    }
    getContactDepartment() {
        const uri = `/api/contact-department`;
        return apiHelper.get(uri);
    }
    deleteContact(data) {
        const uri = `/api/partner/contact`;
        return apiHelper.remove(uri, data)
    }
    deleteBussiness(data) {
        const uri = `/api/partner-vertical-cluster-delete`;
        return apiHelper.post(uri, data)  
    }
    deleteCustomer(data) {
        const uri = `/api/partner-customer`;
        return apiHelper.remove(uri, data)
    }
    deleteBank(data) {
        const uri = `/api/delete/bank-book`;
        return apiHelper.post(uri, data);
    }
    deleteFactory(data) {
        const uri = `/api/factory-book`;
        return apiHelper.remove(uri, data);
    }
    deleteWareHouse(data) {
        const uri = `/api/ware-house`;
        return apiHelper.remove(uri, data);
    }
    deleteSubDivision(data) {
        const uri = `/api/partner-member-category`
        return apiHelper.remove(uri, data)
    }
    deletePartnerProject(data) {
        const uri = `/api/partner-project`;
        return apiHelper.remove(uri, data)
    }
    deleteBusinessVerticals(data) {
        const uri = `/api/partner-vertical-cluster-delete`;
        return apiHelper.post(uri, data)
    }
    deleteBanker(data) {
        const uri = `/api/partner-banker`;
        return apiHelper.remove(uri, data)
    }
    deleteRating(data) {
        const uri = `/api/partner-agency-rating`;
        return apiHelper.remove(uri, data);
    }
    deleteDocument(data) {
        const uri = `/api/file/answer`;
        return apiHelper.remove(uri, data);
    }
    getBranchDropDownByBankName(bankName) {
        const uri = `/api/bank/bank-name/${bankName}`;
        return apiHelper.get(uri);
    }
    downLoadDocument(documentId) {
        const uri = `/api/fileDownload/${documentId}`;
        return apiHelper.downloadFile(uri);
    }
    checkOverAllStatus(categoryCode) {
            const uri = `/api/partner-onboard/modules/category-code/${categoryCode}`
            return apiHelper.get(uri);
        }
        //     api/partner-onboard/general/request-number/{requestNumber}

    // FINANCE:
    // api/partner-onboard/financial/request-number/{requestNumber}

    // DYNAMIC:
    // api/partner-onboard/onboard-questions/module-code/{moduleCode}/request-number/{requestAnswerNumber}

    getBoardingPreviewQuestions(moduleCode, answer) {
        const uri = `/api/partner-onboard/onboard-questions/module-code/${moduleCode}/request-number/${answer}`
        return apiHelper.get(uri);
    }

    getContent(moduleName, answer, isAdmin) {
        // const uri = `/api/partner-summaries/${moduleName}/login-name/${user}/category/${categoryCode}/action-type/${actionType}`
        let uri = `/api/partner-onboard/${moduleName}/request-number/${answer}`
        if(isAdmin){
            uri = `/api/partner-onboard/${moduleName}/request-number/${answer}/isAdmin/true`
        }
        return apiHelper.get(uri)
    }

    getDtValidation(data) {
        const uri = `/api/getDtValidation`
        return apiHelper.post(uri, data);
    }

    enableSubmitButton(categoryCode, companyCode) {
        const uri = `/api/onboard-answer-head/category-code/${categoryCode}/company-code/${companyCode}/verify-mandatory`
        return apiHelper.get(uri)
    }
    checkDunsCode(code) {
        const uri = `/api/partner/verify/duns-number/${code}`
        return apiHelper.get(uri);
    }
    checkCinNumber(cinNumber, companyCode) {
        const uri = `/api/statutory/cin/${cinNumber}`
        return apiHelper.get(uri);
    }
    checkLlpinNumber(llpin, companyCode) {
        const uri = `/api/statutory/llpin/${llpin}`
        return apiHelper.get(uri);
    }
    checkFrnNumber(frn, companyCode) {
        const uri = `/api/statutory/frn/${frn}`
        return apiHelper.get(uri);
    }
    checkSernNumber(sern, companyCode) {
        const uri = `/api/statutory/sern/${sern}`
        return apiHelper.get(uri);
    }
    checkEsiNumber(esiNumber, companyCode) {
        const uri = `/api/statutory/esinumber/${esiNumber}`
        return apiHelper.get(uri);
    }
    checkfactoryInspectorCfNumber(factoryNumber, companyCode) {
        const uri = `/api/statutory/factoryInspectorCfnumber/${factoryNumber}`
        return apiHelper.get(uri);
    }
    checkGSTNumber(gstNumber) {
        const uri = `/api/statutory/gst/${gstNumber}`
        return apiHelper.get(uri);
    }
    checkGSTNumberWithPartnerId(gstNumber, partnersId) {
        const uri = `/api/statutory/gst/${gstNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkCustomerGSTNumberWithPartnerId(gstNumber, partnersId) {
        const uri = `/api/customer/statutory/gst/${gstNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkTANNumber(tanNumber) {
        const uri = `/api/statutory/tan/${tanNumber}`
        return apiHelper.get(uri);
    }
    checkTANNumberWithPartnerId(tanNumber, partnersId) {
        const uri = `/api/statutory/tan/${tanNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkCustomerTANNumberWithPartnerId(tanNumber, partnersId) {
        const uri = `/api/customer/statutory/tan/${tanNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkVatNumber(vatNumber) {
        const uri = `/api/statutory/vat/${vatNumber}`
        return apiHelper.get(uri);
    }
    checkVatNumberWithPartnerId(vatNumber, partnersId) {
        const uri = `/api/statutory/vat/${vatNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkCustomerVATNumberWithPartnerId(vatNumber, partnersId) {
        const uri = `/api/customer/statutory/vat/${vatNumber}/partnersId/${partnersId}`
        return apiHelper.get(uri);
    }
    checkAadhaarNumber(aadhaarNumber, companyCode) {
        const uri = `/api/statutory/aadhaar/${aadhaarNumber}`
        return apiHelper.get(uri);
    }
    checkMSMENumber(msmeNumber, companyCode) {
        const uri = `/api/statutory/msme/${msmeNumber}`
        return apiHelper.get(uri);
    }
    checkshopEstablishmentCfNumber(shopNumber, companyCode) {
        const uri = `/api/statutory/shopEstablishmentCfNumber/${shopNumber}`
        return apiHelper.get(uri);
    }
    checkPfNumber(pfNumber, companyCode) {
        const uri = `/api/statutory/pfnumber/${pfNumber} `
        return apiHelper.get(uri);
    }
    checkDuplicateNumber(statutory) {
        const uri = `/api/statutory/${statutory}`
        return apiHelper.get(uri);
    }
    deleteBranch(branchID, categoryCode, companyCode) {
        const uri = `/api/partner-branch/branch-id/${branchID}/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.remove(uri);
    }
    deleteODDetails(data) {
        const uri = `/api/partner-erp-business-delete`
        return apiHelper.post(uri, data);
    }
    mobileNumberUniqueness(mobileNumber) {
        const uri = `/api/partner/validate/mobile-number/${mobileNumber}`;
        return apiHelper.get(uri)
    }
    emailUniqueness(email) {
        const uri = `/api/partner/validate/email/${email}`
        return apiHelper.get(uri);
    }
    getTrackingData(requestNo) {
        const uri = `/api/document-workflow-messages/request-number/${requestNo}`;
        return apiHelper.get(uri);
    }
    getGenralBranchDetails(companyCode, categoryCode) {
        const uri = `/api/branch/general-module/company-code/${companyCode}/category-code/${categoryCode}`
        return apiHelper.get(uri);
    }
    saveBranchOrganizationDetails(data) {
        const uri = `/api/branch/general/organisation-detail`
        return apiHelper.post(uri, data);
    }
    restrictEmail(email) {
        const uri = `/api/control-parameter/email/${email}`
        return apiHelper.get(uri);
    }
    getBankpaymentMode() {
        const uri = `/api/payment-mode`
        return apiHelper.get(uri);
    }
    saveBranchBankDetails(data, isMigratedUser) {
        const uri = `/api/branch/bank-detail`
        data.isMigratedUser = isMigratedUser
        return apiHelper.post(uri, data);
    }
    saveBranchCredentialsDetails(data) {
        const uri = `/api/branch/credential`
        return apiHelper.post(uri, data);
    }
    saveBranchPartnershipDetails(data) {
        const uri = `/api/branch/partnership-avenue`
        return apiHelper.post(uri, data);
    }
    getMsmeEnterprices() {
        const uri = `/api/enterprise-sector`
        return apiHelper.get(uri);
    }
    getMsmeDeclaration(companyCode, categoryCode) {
        const uri = `/api/declaration?categoryCode=${categoryCode}&companyCode=${companyCode}`
        return apiHelper.get(uri);
    }
    updateMsmeDeclaration(companyCode, categoryCode) {
        const uri = `/api/declaration/acceptance?categoryCode=${categoryCode}&companyCode=${companyCode}`
        return apiHelper.post(uri);
    }

    getBankPaymentMode() {
        const uri = `/api/payment-mode`
        return apiHelper.get(uri);
    }
    checkMandatoryQuestion(companyCode, categoryCode, isInternational) {
        const uri = `/api/verify-mandatory-questions/company-code/${companyCode}/category-code/${categoryCode}/isInternational/${isInternational}`
        return apiHelper.get(uri);
    }
    checkMandatoryStaticQuestion(companyCode, categoryCode, parentCategory, isInternational) {
        const uri = `/api/Verify-Mandatory-Static-Questions/companyCode/${companyCode}/categoryCode/${categoryCode}/parentCategory/${parentCategory}/isInternational/${isInternational}`
        return apiHelper.get(uri);
    }
    getVarReason() {
        const uri = `/api/misc-type-details/misc-code/15`;
        return apiHelper.get(uri);
    }
    getVarType() {
        const uri = `/api/misc-type-details/misc-code/16`;
        return apiHelper.get(uri);
    }
    getVarType() {
        const uri = `/api/misc-type-details/misc-code/16`;
        return apiHelper.get(uri);
    }
    getCustomerList(currentpage, currentperpage, searchTerm) {
        const uri = `/api/customer/getList?pageNo=${currentpage}&pageSize=${currentperpage}&searchTerm=${searchTerm}`;
        return apiHelper.get(uri);
    }
    registerCustomer(data) {
        const uri = `/api/customer/register`
        return apiHelper.post(uri,data);
    }
    getCustomerDetails(data) {
        const uri = `/api/customers/masterData`
        return apiHelper.post(uri,data);
    }
    getCustomerDetailsDesc(data) {
        const uri = `/api/customers/workflow/masterData`
        return apiHelper.post(uri,data);
    }    
    customerSubmitForApproval(data) {
        const uri = `/api/customer-submit`
        return apiHelper.post(uri,data);
    }    
    saveCustomerDetails(data){
        const uri = `/api/customer/onboarding`
        return apiHelper.post(uri,data);
    }
    getCustomerBranchList(data){
        const uri = `/api/customer/new-branches`
        return apiHelper.post(uri,data);        
    }
    getCustomerBankList(data){
        const uri = `/api/customer/new-bank`
        return apiHelper.post(uri,data);        
    }
    deleteCustomerDraftBank(data){
        const uri = `/api/customer/bank-book`
        return apiHelper.post(uri,data);          
    }
    deleteCustomerDraftBranch(data){
        const uri = `/api/customer/branch`
        return apiHelper.post(uri,data);          
    }

    submitTDSDeclaration(data){
        const uri = `/api/submit/tdsDeclaration`
        return apiHelper.post(uri,data);        
    }

    getOnboardingGSTList(companyCode) {
        const uri = `/api/on-boarding/gstin/company-code/${companyCode}`
        return apiHelper.get(uri);
    }

    saveOnboardingGSTList(data) {
        const uri = `/api/on-boarding/gstin`
        return apiHelper.post(uri,data); 
    }
    
    getOnboardingVATList(data) {
        const uri = `/api/on-boarding/getVatDetails`
        return apiHelper.post(uri,data);
    }

    saveOnboardingVATList(data) {
        const uri = `/api/on-boarding/vat`
        return apiHelper.post(uri,data); 
    }

    getOnboardingAddress(data) {
        const uri = `/api/on-boarding/addressDetails`
        return apiHelper.post(uri,data); 
    }

    saveOnboardingAddress(data) {
        const uri = `/api/on-boarding/address`
        return apiHelper.post(uri,data); 
    }
}